import { cn } from '@/lib/utils';
import type { AccountingProvider } from '../../../../../services/accountingIntegration';
import { PROVIDER_LABELS } from './accountingIntegrationUi';

const PROVIDER_LOGO_SRC: Record<AccountingProvider, string> = {
  xero: '/accounting/xero-logo.png',
  quickbooks: '/accounting/quickbooks-logo.png',
};

interface AccountingProviderLogoProps {
  provider: AccountingProvider;
  className?: string;
}

export function AccountingProviderLogo({ provider, className }: AccountingProviderLogoProps) {
  return (
    <img
      src={PROVIDER_LOGO_SRC[provider]}
      alt={`${PROVIDER_LABELS[provider]} logo`}
      className={cn('h-10 w-10 shrink-0 rounded-full object-cover', className)}
      width={40}
      height={40}
      loading="lazy"
    />
  );
}
